import React, {useState, useEffect, useContext} from 'react';
import axios from 'axios';
import { useQuery, useQueryClient } from 'react-query';
import useLocalStorage from 'react-use-localstorage';
import { FormattedMessage } from 'react-intl';
import {useHistory, useLocation, useParams} from 'react-router-dom';
import {PresentationVersion, Version ,VersionList} from "../../src/types/presentation";

import Schedule from './schedule';
import { PreLoader } from '../components/preloader';

import { ScheduleEndpointResponseObject } from '../types/presentation';
import UserContext from "../contexts/user";
import NewSchedule from "./new-schedule";

const NewVideos:React.FC<{
  locale:string; setLocale:any;

}> = ({locale, setLocale}) => {
  const { event_slug,presentation_id } = useParams<{
    event_slug: string,
    presentation_id: string,
  }>();

   console.log("event_slug",event_slug)
  // const intl = useIntl();
  const queryClient = useQueryClient()
  const [fetchData, setFetchData] = useState(false);
  // const slug = new URLSearchParams(document.location.search).get('event') || "invalid";
  const [eventPassword] = useLocalStorage(event_slug, "");

    const location = useLocation();
    console.log(location,"location kitti");
    

    useEffect(() => {
        // This code block will run when the location changes
        console.log('Location changed:', location.pathname);

        // Check if the previous location was not null (i.e., user navigated back)
        // @ts-ignore
        if (location.state && location.state.from) {
            // @ts-ignore
            console.log('Returned', location.state.from);
            // Run your code here
        }
    }, [location]);



  const { data, isLoading, error } = useQuery('event', async () => {

    const url = process.env.REACT_APP_API_ENDPOINT+"/api/public/schedule/"+event_slug
     console.log("url in new video page",url)

    const response = await axios.get<ScheduleEndpointResponseObject>(
        url, {
          params: { password: eventPassword }
        }
    );
    return response.data;
  }, {
    enabled: fetchData,
    onSuccess: (resp) => {
      const { event } = resp.data;
             console.log("event",event);

      resp.data.presentations.forEach((presentation) => {
        queryClient.setQueryData(['presentation', presentation._id], () => ({

          statusCode: 201,
          message: "event.fetch-success",
          data: { event, presentation }
        }))
      })
    }
  });

  useEffect(() => {
    //  console.log('debug: ', data, presentation_id);
    if(!data) {
      //  console.log('debug: fetchData')
      setFetchData(true);
    }
  }, [setFetchData, data]);


  // if (isLoading) return <i>home.tsx: isLoading</i>
  if (isLoading) return <PreLoader />

  if (error || !data) return <div className="login-landing">
    <div className="login-container">
      <div className="login">
        {/* <h4><FormattedMessage id="error.retry.message" /></h4> */}
      </div>
    </div>
  </div>
 console.log("data",data)
  const { data: eventData } = data;

  return <div className="home-container-with-login new-schedule-container">
    <NewSchedule locale={locale} setLocale={setLocale} isSpeaker={true} presentation_id={presentation_id} eventData={eventData}  />
  </div>
}

export default NewVideos;
